// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/football-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/combine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/footer-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/patterns1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/contact-patterns.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/video_img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/testimonials-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/profiles-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../public/athletes_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../public/Squad-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../public/bg-hide.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../public/t-shirt.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-bg {
  display: flex;
  height: 100vh;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.1);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.register-button {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  text-transform: uppercase;
  font-style: italic;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.register-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.contact {
  display: flex;
  height: 100vh;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.footer-bg {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.patterns-bg {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(80 87 255 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: bottom;
  background-repeat: no-repeat;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.contact-bg {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: bottom;
  background-repeat: no-repeat;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.video_bg {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  --tw-backdrop-opacity: opacity(1);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.testimonials {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.profiles-bg {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.athletes_bg {
  display: flex;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.squad-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(80 87 255 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  background-position: center;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.bg-hide {
  display: flex;
  flex-direction: column;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 1.25rem;
  --tw-backdrop-opacity: opacity(0.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.form-field select {
  margin-top: 0.25rem;
  height: 2.5rem;
  border-radius: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.price-switch {
  width: 396px;
  border: 1px solid #545353;
  border-radius: 50px;
  position: relative;
  height: 57px;
  margin: 0 auto;
}

.price-top {
  border: 1px solid #545353;
  border-radius: 50px;
  display: inline-flex;
}

body {
  background-color: #000;
}

.text-outline {
  margin: 0;
  padding: 0;
  color: #fff;
  letter-spacing: 0px;
  text-transform: uppercase;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 2px;
  font-style: italic;
}

.login-divider {
  height: 90%;
  width: 2px;
  position: absolute;
  background: #797878;
  left: 105px;
  top: 58px;
}

.login-or {
  padding: 13px 24px;
  border: 1px solid #545454;
  background: #1e1e1e;
  position: relative;
  left: 58%;
  top: 46%;
}

.login-divider-mob {
  width: 100%;
  height: 2px;
  position: absolute;
  background: #797878;
  left: 0px;
  top: 58px;
}

.login-or-mob {
  padding: 13px 24px;
  border: 1px solid #545454;
  background: #1e1e1e;
  position: relative;
  left: 33%;
  top: 5%;
  display: inline-block;
}

.slick-prev:before,
.slick-next:before {
  font-family: system-ui !important;
  font-size: 26px;
  line-height: 1;
  opacity: 0.75;
  color: white;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid #fff;
  padding: 4px 7px;
  border-radius: 50%;
}

.slick-next {
  right: 20px !important;
}

/* .left-arrow .slick-prev {
  left: -50px !important;
} */
.play-button-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  pointer-events: none;

  #circle-play-b {
    cursor: pointer;
    pointer-events: auto;

    svg {
      /* width: 100px;
      height: 100px; */
      fill: #fff;
      stroke: #fff;
      cursor: pointer;
      background-color: rgba(black, 0.2);
      border-radius: 50%;
      opacity: 0.9;
    }
  }
}

.form-field textarea {
  height: 5rem !important;
}

.event_details_mob {
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background-color: #fff;
  padding: 20px;
  z-index: 40;
}

.modal-popup .shadow-lg {
  box-shadow: none;
}

/* .popup-list .Pop-Height {
  height: 430px !important;
}

@media (width < 40rem) {
  .popup-list .Pop-Height {
    height: 440px !important;
  }
} */

.slick-prev {
  left: 6px !important;
  z-index: 99;
}

.table-truncate {
  white-space: nowrap;
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
}

.form-field input {
  margin-top: 0.25rem;
  height: 3.5rem;
  border-radius: 0.5rem;
  padding-left: 0.8rem;
  padding-right: 0.5rem;
  background: #2d2d2d;
  border: 0;
  color: #fff;
}

.form-field select {
  margin-top: 0.25rem;
  height: 3.5rem;
  border-radius: 0.5rem;
  padding-left: 0.8rem;
  padding-right: 0.5rem;
  background: #2d2d2d;
  border: 0;
  color: #fff;
}

.form-field input:disabled,
.form-field textarea:disabled {
  background: #2d2d2d;
}

/* Hide arrows for Chrome, Safari, Edge */
.no-spinner::-webkit-inner-spin-button,
.no-spinner::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows for Firefox */
.no-spinner {
  -moz-appearance: textfield;
}

.t-shirt {
  position: relative;
  height: 1.25rem;
  width: 3.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: cover;
  background-repeat: no-repeat;
}

.safari-text {
  font-size: 20px !important;
}

/* Add Event calendar page input styles */

.form-field-add input {
  margin-top: 0.25rem;
  height: 2.7rem;
  border-radius: 6px;
  padding-left: 0.8rem;
  padding-right: 0.5rem;
  background: #fff;
  border: 1px solid #ccc;
  color: #000;
}
.form-field-add select {
  margin-top: 0.25rem;
  height: 2.7rem;
  border-radius: 6px;
  padding-left: 0.8rem;
  padding-right: 0.5rem;
  background: #fff;
  border: 1px solid #ccc;
  color: #000;
}
.form-field-add input:disabled,
.form-field-add textarea:disabled {
  background: #f2f2f2;
}
.form-field-add select {
  margin-top: 0.25rem;
  height: 2.5rem;
  border-radius: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.form-field-add textarea {
  height: 5rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AACE;EAAA,aAAsH;EAAtH,aAAsH;EAAtH,sBAAsH;EAAtH,kBAAsH;EAAtH,mDAAsH;EAAtH,yDAAsH;EAAtH,sBAAsH;EAAtH,2BAAsH;EAAtH,mCAAsH;EAAtH;AAAsH;;AAItH;EAAA,kBAAuH;EAAvH,uDAAuH;EAAvH,mBAAuH;EAAvH,sBAAuH;EAAvH,kBAAuH;EAAvH,mBAAuH;EAAvH,iBAAuH;EAAvH,iBAAuH;EAAvH,gBAAuH;EAAvH,yBAAuH;EAAvH,kBAAuH;EAAvH,oBAAuH;EAAvH,gDAAuH;EAAvH,0CAAuH;EAAvH,uDAAuH;EAAvH;AAAuH;;AAAvH;EAAA,kBAAuH;EAAvH,uDAAuH;EAAvH,+EAAuH;EAAvH,mGAAuH;EAAvH;AAAuH;;AAIvH;EAAA,aAAqH;EAArH,aAAqH;EAArH,sBAAqH;EAArH,kBAAqH;EAArH,sDAAqH;EAArH,yDAAqH;EAArH,sBAAqH;EAArH,2BAAqH;EAArH,mCAAqH;EAArH;AAAqH;;AAIrH;EAAA,aAA4G;EAA5G,sBAA4G;EAA5G,kBAA4G;EAA5G,mDAA4G;EAA5G,yDAA4G;EAA5G,sBAA4G;EAA5G,2BAA4G;EAA5G,mCAA4G;EAA5G;AAA4G;;AAI5G;EAAA,aAAmH;EAAnH,sBAAmH;EAAnH,kBAAmH;EAAnH,uDAAmH;EAAnH,yDAAmH;EAAnH,2BAAmH;EAAnH,4BAAmH;EAAnH,mCAAmH;EAAnH;AAAmH;;AAInH;EAAA,aAAsH;EAAtH,sBAAsH;EAAtH,kBAAsH;EAAtH,mDAAsH;EAAtH,yDAAsH;EAAtH,2BAAsH;EAAtH,4BAAsH;EAAtH,mCAAsH;EAAtH;AAAsH;;AAItH;EAAA,aAAsH;EAAtH,sBAAsH;EAAtH,kBAAsH;EAAtH,mDAAsH;EAAtH,yDAAsH;EAAtH,sBAAsH;EAAtH,wBAAsH;EAAtH,4BAAsH;EAAtH,iCAAsH;EAAtH;AAAsH;;AAItH;EAAA,kBAAyG;EAAzG,sDAAyG;EAAzG,yDAAyG;EAAzG,wBAAyG;EAAzG,2BAAyG;EAAzG,mCAAyG;EAAzG;AAAyG;;AAIzG;EAAA,aAAmH;EAAnH,sBAAmH;EAAnH,kBAAmH;EAAnH,sDAAmH;EAAnH,yDAAmH;EAAnH,wBAAmH;EAAnH,2BAAmH;EAAnH,mCAAmH;EAAnH;AAAmH;;AAInH;EAAA,aAAkH;EAAlH,sBAAkH;EAAlH,yDAAkH;EAAlH,wBAAkH;EAAlH,0BAAkH;EAAlH,4BAAkH;EAAlH,mCAAkH;EAAlH;AAAkH;;AAIlH;EAAA,kBAAgG;EAAhG,uDAAgG;EAAhG,yDAAgG;EAAhG,sBAAgG;EAAhG,2BAAgG;EAAhG,mCAAgG;EAAhG;AAAgG;;AAIhG;EAAA,aAA2H;EAA3H,sBAA2H;EAA3H,kBAA2H;EAA3H,yDAA2H;EAA3H,0DAA2H;EAA3H,sBAA2H;EAA3H,2BAA2H;EAA3H,4BAA2H;EAA3H,uBAA2H;EAA3H,mCAA2H;EAA3H;AAA2H;;AAG7H;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;;EAEpB;IACE,eAAe;IACf,oBAAoB;;IAEpB;MACE;sBACgB;MAChB,UAAU;MACV,YAAY;MACZ,eAAe;MACf,kCAAkC;MAClC,kBAAkB;MAClB,YAAY;IACd;EACF;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;AAC5B;;AAGE;EAAA,kBAAmF;EAAnF,eAAmF;EAAnF,aAAmF;EAAnF,0DAAmF;EAAnF,sBAAmF;EAAnF;AAAmF;;AAGrF;EACE,0BAA0B;AAC5B;;AAEA,yCAAyC;;AAEzC;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".hero-bg {\n  @apply bg-[url('../../public/football-bg.jpg')] h-screen bg-center bg-black backdrop-opacity-10 flex flex-col bg-cover;\n}\n\n.register-button {\n  @apply bg-red-500 text-white py-2 px-8 text-2xl font-medium italic uppercase shadow-sm hover:shadow-lg hover:bg-red-700;\n}\n\n.contact {\n  @apply bg-[url('../../public/combine.png')] bg-center h-screen bg-gray-800 backdrop-opacity-20 flex flex-col bg-cover;\n}\n\n.footer-bg {\n  @apply bg-[url('../../public/footer-bg.svg')] bg-center bg-[#000] backdrop-opacity-20 flex flex-col bg-cover;\n}\n\n.patterns-bg {\n  @apply bg-[url('../../public/patterns1.png')] bg-no-repeat bg-bottom bg-[#5057FF] backdrop-opacity-20 flex flex-col;\n}\n\n.contact-bg {\n  @apply bg-[url('../../public/contact-patterns.png')] bg-no-repeat bg-bottom bg-black backdrop-opacity-20 flex flex-col;\n}\n\n.video_bg {\n  @apply bg-[url('../../public/video_img.jpg')] bg-no-repeat bg-top bg-black backdrop-opacity-100 flex flex-col bg-cover;\n}\n\n.testimonials {\n  @apply bg-[url('../../public/testimonials-bg.png')] bg-center bg-[#1E1E1E] backdrop-opacity-20 bg-contain;\n}\n\n.profiles-bg {\n  @apply bg-[url('../../public/profiles-bg.png')] bg-center bg-[#1E1E1E] backdrop-opacity-20 flex flex-col bg-contain;\n}\n\n.athletes_bg {\n  @apply bg-[url('../../public/athletes_bg.png')] bg-right backdrop-opacity-20 flex flex-col bg-contain bg-no-repeat;\n}\n\n.squad-bg {\n  @apply bg-[url('../../public/Squad-bg.png')] bg-center bg-[#5057FF] backdrop-opacity-20 bg-cover;\n}\n\n.bg-hide {\n  @apply bg-[url('../../public/bg-hide.png')] bg-center bg-white backdrop-opacity-20 flex flex-col bg-no-repeat bg-cover pb-5;\n}\n\n.form-field select {\n  margin-top: 0.25rem;\n  height: 2.5rem;\n  border-radius: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.price-switch {\n  width: 396px;\n  border: 1px solid #545353;\n  border-radius: 50px;\n  position: relative;\n  height: 57px;\n  margin: 0 auto;\n}\n\n.price-top {\n  border: 1px solid #545353;\n  border-radius: 50px;\n  display: inline-flex;\n}\n\nbody {\n  background-color: #000;\n}\n\n.text-outline {\n  margin: 0;\n  padding: 0;\n  color: #fff;\n  letter-spacing: 0px;\n  text-transform: uppercase;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke-width: 2px;\n  font-style: italic;\n}\n\n.login-divider {\n  height: 90%;\n  width: 2px;\n  position: absolute;\n  background: #797878;\n  left: 105px;\n  top: 58px;\n}\n\n.login-or {\n  padding: 13px 24px;\n  border: 1px solid #545454;\n  background: #1e1e1e;\n  position: relative;\n  left: 58%;\n  top: 46%;\n}\n\n.login-divider-mob {\n  width: 100%;\n  height: 2px;\n  position: absolute;\n  background: #797878;\n  left: 0px;\n  top: 58px;\n}\n\n.login-or-mob {\n  padding: 13px 24px;\n  border: 1px solid #545454;\n  background: #1e1e1e;\n  position: relative;\n  left: 33%;\n  top: 5%;\n  display: inline-block;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  font-family: system-ui !important;\n  font-size: 26px;\n  line-height: 1;\n  opacity: 0.75;\n  color: white;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: 1px solid #fff;\n  padding: 4px 7px;\n  border-radius: 50%;\n}\n\n.slick-next {\n  right: 20px !important;\n}\n\n/* .left-arrow .slick-prev {\n  left: -50px !important;\n} */\n.play-button-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: auto;\n  pointer-events: none;\n\n  #circle-play-b {\n    cursor: pointer;\n    pointer-events: auto;\n\n    svg {\n      /* width: 100px;\n      height: 100px; */\n      fill: #fff;\n      stroke: #fff;\n      cursor: pointer;\n      background-color: rgba(black, 0.2);\n      border-radius: 50%;\n      opacity: 0.9;\n    }\n  }\n}\n\n.form-field textarea {\n  height: 5rem !important;\n}\n\n.event_details_mob {\n  position: absolute;\n  left: 0;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  background-color: #fff;\n  padding: 20px;\n  z-index: 40;\n}\n\n.modal-popup .shadow-lg {\n  box-shadow: none;\n}\n\n/* .popup-list .Pop-Height {\n  height: 430px !important;\n}\n\n@media (width < 40rem) {\n  .popup-list .Pop-Height {\n    height: 440px !important;\n  }\n} */\n\n.slick-prev {\n  left: 6px !important;\n  z-index: 99;\n}\n\n.table-truncate {\n  white-space: nowrap;\n  width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n}\n\n.form-field input {\n  margin-top: 0.25rem;\n  height: 3.5rem;\n  border-radius: 0.5rem;\n  padding-left: 0.8rem;\n  padding-right: 0.5rem;\n  background: #2d2d2d;\n  border: 0;\n  color: #fff;\n}\n\n.form-field select {\n  margin-top: 0.25rem;\n  height: 3.5rem;\n  border-radius: 0.5rem;\n  padding-left: 0.8rem;\n  padding-right: 0.5rem;\n  background: #2d2d2d;\n  border: 0;\n  color: #fff;\n}\n\n.form-field input:disabled,\n.form-field textarea:disabled {\n  background: #2d2d2d;\n}\n\n/* Hide arrows for Chrome, Safari, Edge */\n.no-spinner::-webkit-inner-spin-button,\n.no-spinner::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide arrows for Firefox */\n.no-spinner {\n  -moz-appearance: textfield;\n}\n\n.t-shirt {\n  @apply bg-[url('../../public/t-shirt.svg')] w-14 h-5 bg-no-repeat relative bg-cover;\n}\n\n.safari-text {\n  font-size: 20px !important;\n}\n\n/* Add Event calendar page input styles */\n\n.form-field-add input {\n  margin-top: 0.25rem;\n  height: 2.7rem;\n  border-radius: 6px;\n  padding-left: 0.8rem;\n  padding-right: 0.5rem;\n  background: #fff;\n  border: 1px solid #ccc;\n  color: #000;\n}\n.form-field-add select {\n  margin-top: 0.25rem;\n  height: 2.7rem;\n  border-radius: 6px;\n  padding-left: 0.8rem;\n  padding-right: 0.5rem;\n  background: #fff;\n  border: 1px solid #ccc;\n  color: #000;\n}\n.form-field-add input:disabled,\n.form-field-add textarea:disabled {\n  background: #f2f2f2;\n}\n.form-field-add select {\n  margin-top: 0.25rem;\n  height: 2.5rem;\n  border-radius: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.form-field-add textarea {\n  height: 5rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
